import React from 'react';
import { Globe2Icon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#061b13] px-5 py-14 text-center" data-id="element-69" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl" data-id="element-70" data-mp="3gh3n22klrk9c">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-emerald-300" data-id="element-71" data-mp="32ovwwtntqrjm">
          P.E. READY 360™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-72" data-mp="36ppn5toqoifo">
          The #1 system for PE teachers worldwide.
        </p>
        <p className="mt-2 text-sm italic text-slate-300" data-id="element-73" data-mp="3ud7h9vvh7slt">
          Because teaching PE shouldn’t cost you every evening of the week.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-emerald-300/20 py-6 text-sm font-semibold text-slate-300" data-id="element-74" data-mp="3ldalzbekzvhs">
          <a className="flex items-center gap-2 hover:text-white" href="mailto:support.peready360@gmail.com" data-id="element-75" data-mp="29z6x2jmuoxjl">
            <MailIcon className="h-4 w-4 text-emerald-300" data-id="element-76" data-mp="2ez1joazlf0yu" />
            support.peready360@gmail.com
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://instagram.com/peready360" data-id="element-77" data-mp="3l9sjt81pyyq2">
            <InstagramIcon className="h-4 w-4 text-emerald-300" data-id="element-78" data-mp="3v7ggw4mssibe" />
            @peready360
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://www.peready360.com" data-id="element-79" data-mp="3q83svgk6x578">
            <Globe2Icon className="h-4 w-4 text-emerald-300" data-id="element-80" data-mp="81pddd69wn6q" />
            www.peready360.com
          </a>
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-81" data-mp="33nogbm61tnc">
          © P.E. READY 360™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}